// Les règles chiffrées appliquées à une gamme, pour l'écran (assistant, étape 3).

/**
 * LES RÈGLES CHIFFRÉES APPLIQUÉES — 14 octobre 2026 (assistant, étape 3).
 * « Règle n° 12 : cycle +20 % — 14,0 → 16,8 min » : sommé sur les lignes
 * qu'elle a touchées. Une ligne retouchée depuis par le deviseur (`corrige`)
 * ne compte plus : son temps est le sien, plus celui de la règle.
 */
export function effetsAppliques(gamme = []) {
  const parRegle = new Map();
  for (const l of gamme ?? []) {
    if (l?.source !== 'ia') continue;
    for (const e of l.effets ?? []) {
      const r = parRegle.get(e.regle_id) ?? { regle_id: e.regle_id, texte: e.texte, avant: 0, apres: 0 };
      r.avant += Number(e.avant) || 0;
      r.apres += Number(e.apres) || 0;
      parRegle.set(e.regle_id, r);
    }
  }
  return [...parRegle.values()];
}
